const isLocal = false;

export const BASE_URL = isLocal ? "http://localhost:3000" : "https://1zone.org";
export const API_BASE_URL = "https://portal.1zone.org/api";
export const ASSET_URL = "https://portal.1zone.org";

export const submitFormData = async (data) => {
    try {
        const response = await fetch(`${API_BASE_URL}/submit-form-data`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        return result;
    } catch (error) {
        return { success: 0 };
    }
}